import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import useGetSumUpData from '../../../utils/hooks/useGetSumUpData';
import { logToAnalytics } from '../../../services/firebase/logToAnalytics';
import SumUpData from '../../SumUp/SumUpData';
import SumUpActions from './SumUpActions';

const SumUpLs = () => {

  const { t } = useTranslation();

  useGetSumUpData();

  useEffect(() => {
    logToAnalytics('SumUpLs_loaded', { name: 'SumUpLs_loaded' });
  }, []);

  return (
    <>
      <SumUpData
        title={t('Result')}
        desc={t('sumUpLs.desc')}
      >
        <SumUpActions />
      </SumUpData>
    </>
  );
};

export default SumUpLs;